import React from 'react';
import type { FC, PropsWithChildren } from 'react';

import StyledGridRootContainer from './styled-components/StyledGridRootContainer';
import StyledGridInnerContainer from './styled-components/StyledGridInnerContainer';

const AppLayoutContainer: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <StyledGridRootContainer
      container
      justifyContent="center"
      alignContent="center"
      direction="column"
    >
      <StyledGridInnerContainer
        container
        justifyContent="flex-start"
        alignContent="center"
        direction="column"
      >
        {children}
      </StyledGridInnerContainer>
    </StyledGridRootContainer>
  );
};

export default AppLayoutContainer;
